

<template>
  <div class="card-headerfrm" style="margin-bottom: 15px">
    <h4 class="header">
      <i class="fa fa-bars barcolor" aria-hidden="true"></i>&nbsp;Shipment
      Details
      <span style="color: red; font-size: 13px"
        >(Total Records : {{ totalCountOfData }})</span
      >
    </h4>
    <input type="checkbox" name="actionToggle" @click="toggle()" />

    <vue-element-loading spinner="line-scale" color="#FF6700" />Select Bulk
    Accept Dispute
    <div style="overflow-x: auto">
      <table class="table-bordered table-hover tbl datatables">
        <thead>
          <tr class="text-primary">
            <th class="text-center tableheader">
              <b-link
                class="btn btn-sm btn-success"
                @click="$emit('AcceptDispute', bulkAWB)"
              >
              Accept Dispute
              </b-link>
            </th>
            <th class="text-center tableheader"><b>Action</b></th>
            <th class="text-center tableheader"><b>AWB Number</b></th>
            <th class="text-center tableheader"><b>Client Name</b></th>
            <th class="text-center tableheader"><b>OctroiMRP</b></th>
            <th class="text-center tableheader"><b>Current HubName</b></th>
            <th class="text-center tableheader"><b>Origin HubName</b></th>
            <th class="text-center tableheader"><b>Destination HubName</b></th>
            <th class="text-center tableheader"><b>DEPS Logged By</b></th>
            <th class="text-center tableheader"><b>Order Type</b></th>
            <th class="text-center tableheader"><b>Physical Weight</b></th>
            <th class="text-center tableheader"><b>Volumetric Weight</b></th>
            <th class="text-center tableheader"><b>Logged Date</b></th>
            <th class="text-center tableheader"><b>Logged Desc</b></th>
            <th class="text-center tableheader"><b>Product Desc</b></th>
            <th class="text-center tableheader"><b>Last Status</b></th>
            <th class="text-center tableheader"><b>Verification Action</b></th>
            <th class="text-center tableheader"><b>Last Modified By</b></th>
            <th class="text-center tableheader"><b>Manifest InScan Date</b></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="totalCountOfData == 0">
            <td colspan="31" style="color: red" align="center">
              No record found
            </td>
          </tr>
          <tr v-for="data in shipmentData">
            <td class="action-td">
              <input
                type="checkbox"
                name="chk-shipment"
                :id="data.shippingid"
                :value="{ shippingid: data.shippingid }"
                v-model="bulkAWB"
              />
              <span class="Accept">Accept Dispute</span>
            </td>

            <td>
              <span
                class="action"
                @click="$emit('UpdatePage', data.shippingid)"
              >
                Take Action
              </span>
            </td>

            <td>{{ data.shippingid }}</td>
            <td>{{ clientDetails[data.clientid] }}</td>
            <td>{{ data.declaredvalue }}</td>
            <td>{{ hubList[data.currenthubid] }}</td>
            <td>{{ hubList[data.originhubid] }}</td>
            <td>{{ hubList[data.finaldestinationid] }}</td>
            <td>{{ data.createdby }}</td>
            <td>{{ data.ordertype }}</td>
            <td>{{ data.phyweight }}</td>
            <td>{{ data.volweight }}</td>
            <td>
              {{
                data.createddate
                  ? new Date(data.createddate).toLocaleDateString()
                  : "-"
              }}
            </td>
            <td>{{ data.loggeddescription }}</td>
            <td>{{ data.productinformation }}</td>
            <td>{{statusList[data.status]}}</td>
            <td>{{actioncodeList[data.actionstatuscode]}}</td>
            <td>{{ data.lastmodifiedby }}</td>
            <td>
              {{
                data.lastmodifieddate
                  ? new Date(data.lastmodifieddate).toLocaleDateString()
                  : "-"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
  </div>
</template>

<script>
import VueElementLoading from "vue-element-loading";

export default {
  name: "resultGrid",
  components: {
    VueElementLoading,
  },
  props: {
    shipmentData: {
      type: Array,
      required: true,
    },
    clientDetails: {
      type: Array,
      required: true,
    },
    totalCountOfData: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      damageType: {},
      bulkAWB: [],
      hubList:[],
      statusList:[],
      actioncodeList:[]
    };
  },
  mounted() {
    this.hubList = JSON.parse(window.localStorage.getItem("hubList"));
    this.statusList = JSON.parse(window.localStorage.getItem("statusList"));
    this.actioncodeList = JSON.parse(window.localStorage.getItem("actioncodeList"));
    var userToken = window.localStorage.getItem("accessuserToken");
    this.myStr = userToken.replace(/"/g, "");
    this.damageType = {
      1: "Minor",
      2: "Major",
    };
  },
  watch: {},
  methods: {
    toggle() {
      let checkboxes = document.getElementsByName("chk-shipment");
      let actionCheckbox = document.getElementsByName("actionToggle");
      for (var i = 0, n = checkboxes.length; i < n; i++) {
        if (actionCheckbox[0].checked) {
          if (!checkboxes[i].checked) {
            checkboxes[i].click();
          }
        } else {
          if (checkboxes[i].checked) {
            checkboxes[i].click();
          }
        }
      }
    },
    resetForm() {
      this.hub = this.newhubs = this.awbnumber = "";
      this.isLoading = false;
      this.$validator.reset();
      this.errors.clear();
    },
  },
};
</script>


<style src="./actionComponent.component.scss" scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/B2B components/resultGridOfRMAproval.vue?dcd7ceaa